import { HTTP_OPTIONS } from 'app/_helper/header.config';
import { FormModel } from './../_models/form.model';
import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, lastValueFrom } from 'rxjs';
import { RecordSearchModel } from './../_models/recordsearch.model';
import { environment } from 'environments/environment';
import * as moment from 'moment';
import { FormDefinition } from 'app/_models/formdefinition.model';
import { ReportExecution } from 'app/_models/report-execution.model';
import { AuthService } from './auth.service';
import { UserRoles } from 'app/_models/userroles';
import { FormSearchModel } from '../_models/formsearch.model';

@Injectable({
  providedIn: 'root',
})
export class FormsService {
  // firstLoad: boolean;
  dataEditorChange: BehaviorSubject<any> = new BehaviorSubject(null);
  templateRecordDeleted = signal<boolean>(false);
  templateDefinitionDeleted = signal<boolean>(false);
  completedRecord = signal<boolean>(false);
  $forms = signal<FormModel[]>([]);
  // private timeOut: any;

  constructor(private http: HttpClient, private _authService: AuthService) {
    // this.timeOut = moment.now();
    // this.firstLoad = true;
  }
  //TODO: Not sure we need this buffering
  // public async getForms(filter: FormSearchModel): Promise<FormModel[]> {
  //   var spanshot = moment.now();

  //   var difference = (spanshot - this.timeOut) / (1000 * 60); //minutes

  //   if (difference > 5 || this.firstLoad) {
  //     this.firstLoad = false;
  //     let forms = await lastValueFrom(this.http.post<FormModel[]>(`${environment.BASEURLAPI}${environment.FORMSURL}`, filter));
  //     this.$forms.set(forms);
  //   }

  //   return this.$forms();
  // }

  // async getForms(filter: FormSearchModel = new FormSearchModel()): Promise<FormModel[]> {
  //   return await lastValueFrom(this.http.post<FormModel[]>(`${environment.BASEURLAPI}/api/forms/searchforms`, JSON.stringify(filter), HTTP_OPTIONS))
  // }

  async getForms(): Promise<FormModel[]> {
    var forms = await lastValueFrom(this.http.get<FormModel[]>(`${environment.BASEURLAPI}/api/forms`));
    this.$forms.set(forms);
    return this.$forms();
  }
  // get a form definition
  public async getFormById(formId: any) {
    return await lastValueFrom(this.http.get<FormDefinition>(`${environment.BASEURLAPI}${environment.FORMSURL}${'/'}${formId}`, HTTP_OPTIONS));
  }

  //Get completed records based on the filters
  public async getCompletedRecords(formId: any, filters: RecordSearchModel) {
    return await lastValueFrom(this.http.post<any[]>(`${environment.BASEURLAPI}${environment.FORMSURL}${'/'}${formId}${'/'}${environment.FORMRECORDURL}`, JSON.stringify(filters), HTTP_OPTIONS));
  }

  async getReportContent(filters: ReportExecution): Promise<Blob> {
    ///api/Forms/{Id}/completedrecords/{rowId}/reports
    var formId = filters.formId;
    var rowId = filters.rowId;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });

    return await lastValueFrom(
      this.http.get<Blob>(
        `${environment.BASEURLAPI}${environment.FORMSURL}${'/'}${formId}${'/'}${environment.COMPLETEDRECORDURL}${'/'}${rowId}${'/reports?ReportId='}${filters.reportId}${'&ReportFormat='}${
          filters.reportFormat
        }`,
        { headers: headers, responseType: 'blob' as 'json' }
      )
    );
  }
  async getRevisionHistory(originalId, formId) {
    return await lastValueFrom(this.http.get(`${environment.BASEURLAPI}${environment.FORMSURL}${'/'}${formId}${'/'}${environment.COMPLETEDRECORDURL}${'/'}${originalId}/revisionhistory`));
  }

  //TODO: Move this into authservice
  isShareRolePresent() {
    const data = this._authService.getDecodedAccessToken(localStorage.getItem('accessToken'));
    const userRole = JSON.parse(data.Roles);
    const role = userRole.filter((e) => e.Name == UserRoles.Forms_Share_Form_Data);
    if (role.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  //Patch Form
  public async patchForm(formId, update) {
    return await lastValueFrom(this.http.patch<any[]>(`${environment.BASEURLAPI}/api/forms/${formId}`, update));
  }

  //Get record templates defination
  public async getRecordTemplatesDefinition() {
    return await lastValueFrom(this.http.get<any[]>(`${environment.BASEURLAPI}${environment.FORMSURL}${'/'}RecordTemplateDefinitions`));
  }

  //save record templates defination
  public async CreateRecordTemplatesDefinition(formId, data) {
    return await lastValueFrom(this.http.put<any>(`${environment.BASEURLAPI}${environment.FORMSURL}/${formId}/recordtemplatedefinition`, data));
  }

  //Get record templates defination
  public async getRecordTemplateDefinition(formId) {
    return await lastValueFrom(this.http.get<any>(`${environment.BASEURLAPI}${environment.FORMSURL}/${formId}/RecordTemplateDefinition`));
  }

  //Get record templates defination value
  public async getRecordTemplates(formId) {
    return await lastValueFrom(this.http.get<any[]>(`${environment.BASEURLAPI}${environment.FORMSURL}/${formId}/RecordTemplates`));
  }

  //Delete record templates defination value
  public async deleteRecordTemplate(formId, recordtemplatedefinitionId) {
    return await lastValueFrom(this.http.delete<any[]>(`${environment.BASEURLAPI}${environment.FORMSURL}/${formId}/recordtemplatedefinition/${recordtemplatedefinitionId}`));
  }

  //save record templates item value
  public async saveTemplateRecordItemValue(formId, jsonData) {
    return await lastValueFrom(this.http.post<any[]>(`${environment.BASEURLAPI}${environment.FORMSURL}/${formId}/recordtemplates`, jsonData));
  }

  //save record templates item value
  public async editTemplateRecordItemValue(formId, recordTemplateId, jsonData) {
    return await lastValueFrom(this.http.put<any[]>(`${environment.BASEURLAPI}${environment.FORMSURL}/${formId}/recordtemplates/${recordTemplateId}`, jsonData));
  }

  //Delete record templates item value
  public async deleteTemplateRecordItem(formId, recordTemplateId) {
    return await lastValueFrom(this.http.delete<any[]>(`${environment.BASEURLAPI}${environment.FORMSURL}/${formId}/recordtemplate/${recordTemplateId}`));
  }

  //check approval enabled on form
  public async isApprovalEnabled(formId) {
    return await lastValueFrom(this.http.get<boolean>(`${environment.BASEURLAPI}${environment.FORMSURL}/IsApprovalsEnabled/${formId}`));
  }
}
